import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SupportIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_528_1304)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.1875 13.25H2.65625C2.09266 13.25 1.55216 13.0261 1.15365 12.6276C0.755133 12.2291 0.53125 11.6885 0.53125 11.125V9C0.53125 8.43645 0.755133 7.89592 1.15365 7.4974C1.55216 7.09888 2.09266 6.875 2.65625 6.875H3.1875C3.32839 6.875 3.46352 6.93097 3.56315 7.0306C3.66278 7.13023 3.71875 7.26536 3.71875 7.40625V12.7187C3.71875 12.8596 3.66278 12.9948 3.56315 13.0944C3.46352 13.194 3.32839 13.25 3.1875 13.25Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.3437 13.25H13.8125C13.6716 13.25 13.5365 13.194 13.4369 13.0944C13.3372 12.9948 13.2812 12.8596 13.2812 12.7187V7.40625C13.2812 7.26536 13.3372 7.13023 13.4369 7.0306C13.5365 6.93097 13.6716 6.875 13.8125 6.875H14.3437C14.9073 6.875 15.4478 7.09888 15.8463 7.4974C16.2448 7.89592 16.4687 8.43645 16.4687 9V11.125C16.4687 11.6885 16.2448 12.2291 15.8463 12.6276C15.4478 13.0261 14.9073 13.25 14.3437 13.25Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.65625 6.875C2.65625 5.32514 3.27193 3.83876 4.36785 2.74285C5.46376 1.64693 6.95014 1.03125 8.5 1.03125C10.0498 1.03125 11.5363 1.64693 12.6321 2.74285C13.7281 3.83876 14.3437 5.32514 14.3437 6.875",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.625 15.9062H12.2187C12.7823 15.9062 13.3228 15.6823 13.7213 15.2838C14.1198 14.8853 14.3437 14.3448 14.3437 13.7812V13.25",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.5625 16.9687H8.5C8.21822 16.9687 7.94792 16.8568 7.74867 16.6576C7.54942 16.4583 7.4375 16.188 7.4375 15.9062C7.4375 15.6245 7.54942 15.3542 7.74867 15.1549C7.94792 14.9557 8.21822 14.8438 8.5 14.8438H9.5625C9.84427 14.8438 10.1146 14.9557 10.3138 15.1549C10.5131 15.3542 10.625 15.6245 10.625 15.9062C10.625 16.188 10.5131 16.4583 10.3138 16.6576C10.1146 16.8568 9.84427 16.9687 9.5625 16.9687Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.375 6.34383C6.37508 5.95427 6.48223 5.57222 6.68477 5.23945C6.8873 4.90667 7.1774 4.63598 7.52342 4.45694C7.86937 4.27791 8.25796 4.19743 8.64655 4.2243C9.03522 4.25117 9.409 4.38436 9.72705 4.6093C10.0451 4.83425 10.2952 5.14229 10.45 5.49978C10.6048 5.85726 10.6584 6.25042 10.6048 6.63628C10.5513 7.02215 10.3927 7.38588 10.1464 7.68773C9.90016 7.98955 9.5756 8.21784 9.20833 8.34768C9.00107 8.42099 8.82165 8.55671 8.69479 8.7362C8.56793 8.91576 8.49986 9.13018 8.5 9.34997V9.5313",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.5 12.1875C8.3533 12.1875 8.23438 12.0686 8.23438 11.9219C8.23438 11.7752 8.3533 11.6562 8.5 11.6562",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.5 12.1875C8.6467 12.1875 8.76562 12.0686 8.76562 11.9219C8.76562 11.7752 8.6467 11.6562 8.5 11.6562",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_528_1304",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "17",
                        height: "17",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
